<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card  p-shadow-1">
				<h5>Marcação Online</h5>
                <hr>

                <TabView @tab-change="validarTab">

                    <TabPanel header="Autorização" class="p-mt-3">
                        <ProgressBar :value="percentEmpEnviados" class="p-mb-2" v-if="processando"/>
                        <IKFiltroFuncionarioContrato ref="ikFiltroFuncionarios"/>
                        <Button label="Enviar" icon="pi pi-check" class="p-mt-5" @click="confirmarCriarDispositivos"/> 
                    </TabPanel>	

                    <TabPanel header="Dispositivos" class="p-mt-3">

                        <DataTable :value="dispositivos" class="p-datatable-sm p-datatable-striped">
                            <template #header>
                                <div class="p-d-flex p-jc-between">	
                                    <div>
                                        <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" class="p-mr-2"
                                            optionValue="id" placeholder="Selecione uma Empresa..." style="min-width: 350px;" @change="buscar"/>
                                        <InputText v-model.trim="crachaNome" placeholder="crachá/pis/cpf/nome" 
                                            class="p-mr-2" style="width: 250px" 
                                            v-on:keyup.enter="buscar" 
                                            @keyup="crachaNome = crachaNome.replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/g, ' ')"
                                            :disabled="!idCnpjSelecionado"/>
                                        <Button icon="pi pi-search" label="Buscar" title="Buscar" class="p-mr-2" 
                                            :disabled="!idCnpjSelecionado" @click="buscar"/>
                                    </div>
                                </div>
                            </template>
                            <Column field="descricao" header="Descrição" sortable></Column>
                            <Column field="tipo" header="Tipo" sortable></Column>
                            <Column field="dataCadastro" header="Data Cadastro" sortable>
                                <template #body="slotProps">
                                    {{ formatarData(slotProps.data.dataCadastro) }}
                                </template>
                            </Column>
                            <Column field="dataAtualizacao" header="Data Atualização" sortable>
                                <template #body="slotProps">
                                    {{ formatarData(slotProps.data.dataAtualizacao) }}
                                </template>
                            </Column>	
                            <Column field="dataAtivacao" header="Data Ativação" sortable>
                                <template #body="slotProps">
                                    {{ formatarData(slotProps.data.dataAtivacao) }}
                                </template>                                
                            </Column>	
                            <Column field="dataUltimaSincronia" header="Última Sincronia" sortable>
                                <template #body="slotProps">
                                    {{ formatarData(slotProps.data.dataUltimaSincronia) }}
                                </template>
                            </Column>
                            <Column field="ativo" header="Ativo" sortable>
                                <template #body="slotProps">
                                    <label v-if="slotProps.data.ativo">Sim</label>
                                    <label v-else>Não</label>
                                </template>                                
                            </Column>
                            <Column field="nomeFuncionario" header="Funcionário" sortable></Column>
                            <Column>
                                <template #body="slotProps">                    
                                    <SplitButton label="Ações" class="p-button-secondary" :model="maisAcoes(slotProps.data)" appendTo="body" ></SplitButton>
                                </template>
                            </Column>
                        </DataTable>

                        <Paginacao ref="paginacao" :qtdLinhasPorPagina="[10,15,20,30]" :callback="listarPorPagina"/>

                    </TabPanel>		

                </TabView>

            </div>
        </div>   

        <Dialog :visible.sync="exibirDialogMensagem" header="Mensagem" :modal="true" :style="{width: '450px'}" @hide="exibirDialogMensagem=false">
            <div class="confirmation-content">
				<label v-html="mensagemRedefinirSenha"></label>
			</div>
			<template #footer>
				<Button label="OK" icon="pi pi-check" @click="exibirDialogMensagem=false" />
			</template>
		</Dialog>

        <Dialog :visible.sync="exibirDialogPermissoes" header="Permissoes" :modal="true" :style="{width: '30vw'}" @hide="fecharNovo">
            <div class="confirmation-content" v-if="dispositivoEditar">	
                <label><b>Tipo</b>: {{ dispositivoEditar.tipo }}</label><br/>
                <label><b>Descrição</b>: {{ dispositivoEditar.descricao }}</label><br/>
				<label><b>Funcionário</b>: {{ dispositivoEditar.nomeFuncionario }}</label>			
                <div class="p-grid p-mt-3">                            
                    <div class="p-col-6">
                        <h6 class="p-text-bold">{{ dispositivoEditar.tipo == 'Mob' ? 'Marcação de Ponto via Celular' : 'Marcação de Ponto via Web' }}</h6>
                        <div class="p-fluid p-formgrid p-grid p-mt-3">                           
                            <div class="p-field p-col-12" v-for="item in dispositivoEditar.permissoes" :key="item.nome">                               
                                <div class="p-field-checkbox">
                                    <Checkbox v-model="item.selecionado" :binary="true"/>
                                    <label>{{ item.label }}</label>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>	                     
			</div>
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharNovo"/>
				<Button label="Salvar" icon="pi pi-check" @click="atualizarPemrissoes"/>
			</template>
		</Dialog>

        <Dialog :visible.sync="exibirDialogDispositivo" header="Confirmar" :modal="true" :style="{width: '40vw'}" @hide="fecharNovo">
            <div class="confirmation-content">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem;" />
				<span>Criar Dispositivos?</span><br/><br/>
				<label><b>Dispositivo</b>:</label><br/>
                <div class="p-formgroup-inline p-mt-2 p-mb-2">
                    <div class="p-field-radiobutton">
                        <RadioButton name="tipoDispositivoSelecionado" value="Mob" v-model="tipoDispositivoSelecionado"/>
                        <label>Celular</label>								
                    </div>
                    <div class="p-field-radiobutton">
                        <RadioButton name="tipoDispositivoSelecionado" value="Web" v-model="tipoDispositivoSelecionado"/>
                        <label>Web</label>												
                    </div>
                    <div class="p-field-radiobutton">
                        <RadioButton name="tipoDispositivoSelecionado" value="Todos" v-model="tipoDispositivoSelecionado"/>	
                        <label>Todos</label>											
                    </div>								
                </div>        
                <label><b>Funcionário(s) Selecionado(s)</b>: {{ quantidadeFuncionarios }}</label> 
              
                <div class="p-grid p-mt-3" v-if="tipoDispositivoSelecionado">                            
                    <div class="p-col-6" v-if="tipoDispositivoSelecionado == 'Todos' || tipoDispositivoSelecionado == 'Mob'">
                        <h6 class="p-text-bold">Marcação de Ponto via Celular</h6>
                        <div class="p-fluid p-formgrid p-grid p-mt-3">                           
                            <div class="p-field p-col-12" v-for="item in permissoesMob" :key="item.nome">                               
                                <div class="p-field-checkbox">
                                    <Checkbox v-model="item.selecionado" :binary="true"/>
                                    <label>{{ item.label }}</label>
                                </div>
                            </div>                            
                        </div>
                    </div>
                    <div class="p-col-6" v-if="tipoDispositivoSelecionado == 'Todos' || tipoDispositivoSelecionado == 'Web'">
                        <h6 class="p-text-bold">Marcação de Ponto via Web</h6>
                        <div class="p-fluid p-formgrid p-grid p-mt-3">                           
                            <div class="p-field p-col-12" v-for="item in permissoesWeb" :key="item.nome">                               
                                <div class="p-field-checkbox">
                                    <Checkbox v-model="item.selecionado" :binary="true"/>
                                    <label>{{ item.label }}</label>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>                

			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="fecharNovo"/>
				<Button label="Sim" icon="pi pi-check" @click="salvar" :disabled="!tipoDispositivoSelecionado"/>
			</template>
		</Dialog>

        <Dialog :visible.sync="exibirDialogRedefinirSenha" header="Confirmar" :modal="true" :style="{width: '450px'}" @hide="exibirDialogRedefinirSenha=false">
            <div class="confirmation-content" v-if="dispositivoEditar">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem;" />
				<span>Gerar Código para Redefinir Senha?</span><br/><br/>
				<label><b>Tipo</b>: {{ dispositivoEditar.tipo }}</label><br/>
                <label><b>Descrição</b>: {{ dispositivoEditar.descricao }}</label><br/>
				<label><b>Funcionário</b>: {{ dispositivoEditar.nomeFuncionario }}</label>
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogRedefinirSenha=false"/>
				<Button label="Sim" icon="pi pi-check" @click="gerarCodigoRedefinirSenha" />
			</template>
		</Dialog>

        <Dialog :visible.sync="exibirDialogAtivacao" header="Confirmar" :modal="true" :style="{width: '450px'}" @hide="exibirDialogAtivacao=false">
            <div class="confirmation-content" v-if="dispositivoEditar">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem;" />
				<span>Gerar Código de Ativação?</span><br/><br/>
				<label><b>Tipo</b>: {{ dispositivoEditar.tipo }}</label><br/>
                <label><b>Descrição</b>: {{ dispositivoEditar.descricao }}</label><br/>
				<label><b>Funcionário</b>: {{ dispositivoEditar.nomeFuncionario }}</label>
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogAtivacao=false"/>
				<Button label="Sim" icon="pi pi-check" @click="gerarCodigoAtivacao" />
			</template>
		</Dialog>
        
        <Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}" @hide="exibirDialogConfirmarExcluir=false">
			<div class="confirmation-content" v-if="dispositivoEditar">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
				<span>Excluir Dispositivo?</span><br/><br/>
				<label><b>Tipo</b>: {{ dispositivoEditar.tipo }}</label><br/>
                <label><b>Descrição</b>: {{ dispositivoEditar.descricao }}</label><br/>
				<label><b>Funcionário</b>: {{ dispositivoEditar.nomeFuncionario }}</label>
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarExcluir=false"/>
				<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
			</template>
		</Dialog>

    </div>
</template>

<script>
import IKFiltroFuncionarioContrato from '@/components/template/IKFiltroFuncionarioContrato';
import Paginacao from '@/components/template/Paginacao.vue';
import DispositivoService from '@/service/DispositivoService.js';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
    dispositivoService: null,	
    data() {
        return {    
            tipoDispositivoSelecionado: null,
            quantidadeFuncionarios: 0,
            mensagemRedefinirSenha: '', 
            exibirDialogPermissoes: false,
            exibirDialogDispositivo: false,
            exibirDialogMensagem: false,
            exibirDialogAtivacao: false,
            exibirDialogRedefinirSenha: false,
            exibirDialogConfirmarExcluir: false,
            processando: false,      
            percentEmpEnviados: null,      
            dispositivos: [],
            filtro: {},
            cnpjs: [],
            idCnpjSelecionado: null,
            cnpjSalvarListaSelecionado: null,
            dispositivoEditar: null,            
            qtdLinhasPorPagina: 10,
            numPagina: 1,
            crachaNome: '',
            cacheCrachaNome: '',
            pararTimeout: false,
            permissoesMob: [
                { label: 'Registrar Ponto', nome: 'registrarPonto', selecionado: true },
                { label: 'Incluir Marcação', nome: 'incluirMarcacao', selecionado: true },
                { label: 'Justificar Ponto', nome: 'justificarPonto', selecionado: true },
                { label: 'Relatório de Horas', nome: 'relatorioHoras', selecionado: true }
            ],
            permissoesWeb: [
                { label: 'Registrar Ponto', nome: 'registrarPonto', selecionado: true },
                { label: 'Incluir Marcação', nome: 'incluirMarcacao', selecionado: true },
                { label: 'Justificar Ponto', nome: 'justificarPonto', selecionado: true },
                { label: 'Relatório de Horas', nome: 'relatorioHoras', selecionado: true }
            ]
        }        
    },
	methods: {
        ...mapGetters('sessao', ['getDadosRequisicao', 'getPermissoes']),
        /**
         * 
         */
         async copiarCodigoAtivacao(dispositivo) {          
             let codigo = (dispositivo.codigoAtivacao ? dispositivo.codigoAtivacao : ''); 
			try {                
				await navigator.clipboard.writeText(codigo);
                exibirMensagemSis(this, 'Sucesso', false);				
			} catch (err) {
                this.mensagemRedefinirSenha = 'Código de ativação <b>'+codigo+'</b>.';
				this.exibirDialogMensagem = true;
				console.error(err);
			}		
        },
        /**
         * 
         */
        confirmarCriarDispositivos() {
            this.cnpjSalvarListaSelecionado = null;
            let dados = this.$refs.ikFiltroFuncionarios.getFiltro();
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione o(s) funcionário(s)', true);
                return;
            }
            this.cnpjSalvarListaSelecionado = {...dados.cnpj};
            this.quantidadeFuncionarios = dados.funcionarios.length;
            this.exibirDialogDispositivo = true;
        },
        /**
         * 
         */
        salvar() {
            let dados = this.$refs.ikFiltroFuncionarios.getFiltro();
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione o(s) funcionário(s)', true);
                return;
            }
            if(!this.tipoDispositivoSelecionado) {
                exibirMensagemSis(this, 'Selecione o dispositivo', true);
                return;
            }
            this.exibirDialogDispositivo = false;
            let qtdFuncionarios = dados.funcionarios.length
            let limiteLista = 50;            
            let idsFuncionarios = [];
            let lotes = [];
            dados.funcionarios.forEach((funcio, index) => {
                idsFuncionarios.push(funcio.id);
                if(idsFuncionarios.length == limiteLista || ((index + 1) == qtdFuncionarios)) {
                    lotes.push([...idsFuncionarios]);
                    idsFuncionarios = [];                    
                }                
            });
            this.percentEmpEnviados = 0;
            if(qtdFuncionarios <= limiteLista) {
                this.percentEmpEnviados = 50;
            }
            this.processando = true;
            this.salvarRecursivo(lotes, 0);
        },
        /**
         *  
         */
        salvarRecursivo(lotes, pagina) {
            if(this.pararTimeout) {
                return;
            }
            let tiposDispositivos = [];
            let pMob = [];
            let pWeb = [];
            if(this.tipoDispositivoSelecionado == 'Todos') {
                tiposDispositivos = ['Mob', 'Web'];
                pMob = this.permissoesMob;
                pWeb = this.permissoesWeb;
            } else {
                tiposDispositivos = [this.tipoDispositivoSelecionado];
                if(this.tipoDispositivoSelecionado == 'Mob') {
                    pMob = this.permissoesMob;
                } else {
                    pWeb = this.permissoesWeb;
                }
            }
            let dispositivoRequest = {
                idsFuncionarios: lotes[pagina],
                cnpj: this.cnpjSalvarListaSelecionado,
                tiposDispositivos: tiposDispositivos,
                permissoesMob: pMob,
                permissoesWeb: pWeb,
                ultimaPagina: ((pagina + 1) == lotes.length)
            }
            let requisicao = {
                usuarioRequisicao: {...this.getDadosRequisicao()},
                dispositivoRequest: dispositivoRequest,
            }
            this.dispositivoService.salvar(requisicao)
            .then(resp => {
                pagina++;
                let percent = parseInt((((pagina) / lotes.length)*100));  
                if(percent > 100) {
                    percent = 100;
                }
                this.percentEmpEnviados = percent;
                if(pagina < lotes.length) {
                    this.salvarRecursivo(pagina, lotes);
                } else {
                    setTimeout(() => {
                        this.processando = false;
                    }, 2000);
                    this.tipoDispositivoSelecionado = null;
                    exibirMensagem(this, resp);	
                }                                  
            })
            .catch(erro => {
                this.processando = false;
                this.percentEmpEnviados = 0;
                exibirMensagem(this, erro)
            });
        },
        /**
         * 
         */
         atualizarPemrissoes() {           
            let requisicao = {
                usuarioRequisicao: {...this.getDadosRequisicao()},
                dispositivoRequest: {
                    idDispositivo: this.dispositivoEditar.id,
                    permissoes: this.dispositivoEditar.permissoes
                }
            }
            this.dispositivoService.atualizarPermissoes(requisicao)
            .then(resp => {
                exibirMensagem(this, resp);
                this.exibirDialogPermissoes = false;
                this.dispositivoEditar = null;            
                this.buscar();                        
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        gerarCodigoAtivacao() {
            let dispositivo = {
                id: this.dispositivoEditar.id,
                tipo: this.dispositivoEditar.tipo,
                descricao: this.dispositivoEditar.descricao
            }  
            let cnpjSelecionado = this.cnpjs.filter(cnpj => cnpj.id == this.idCnpjSelecionado)[0];
            let requisicao = {
                usuarioRequisicao: {...this.getDadosRequisicao()},
                cnpj: cnpjSelecionado,
                idDispositivo: dispositivo.id
            }
            this.dispositivoService.gerarCodigoAtivacao(requisicao)
            .then(resp => {
                exibirMensagem(this, resp);
                this.exibirDialogAtivacao = false;
                this.dispositivoEditar = null;            
                this.buscar();                        
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        gerarCodigoRedefinirSenha() {
            let requisicao = {
                idDispositivo: this.dispositivoEditar.id,
                usuarioRequisicao: {...this.getDadosRequisicao()}               
            }
            this.dispositivoService.gerarCodigoRedefinirSenha(requisicao)
            .then(resp => {
                this.mensagemRedefinirSenha = resp.data.mensagem;                
                this.exibirDialogMensagem = true;
                this.exibirDialogRedefinirSenha = false;
                this.dispositivoEditar = null;            
                this.buscar();                        
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        excluir() {
            let dispositivo = {
                id: this.dispositivoEditar.id,
                tipo: this.dispositivoEditar.tipo,
                descricao: this.dispositivoEditar.descricao
            }            
            let requisicao = {
                usuarioRequisicao: {...this.getDadosRequisicao()},
                idDispositivo: dispositivo.id,
            }
            this.dispositivoService.excluir(requisicao)
            .then(resp => {
                exibirMensagem(this, resp);
                this.exibirDialogConfirmarExcluir = false;
                this.dispositivoEditar = null;            
                this.buscar();                        
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        buscar() {
            let qtdLinhasPorPagina = 10;
            let numPagina = 1;
            let crachaNome = this.crachaNome;
            this.cacheCrachaNome = this.crachaNome;          
            this.listar(crachaNome, numPagina, qtdLinhasPorPagina);
        },     
        /**
         * 
         */
        listarPorPagina(paginacao) {
            let qtdLinhasPorPagina = paginacao.linhas;
            let numPagina = paginacao.pagina;
            this.listar(this.cacheCrachaNome, numPagina, qtdLinhasPorPagina);
        },
        /**
         * 
         */
        listar(crachaNome, numPagina, qtdLinhasPorPagina) {
            let requisicao = {  
                qtdLinhas: qtdLinhasPorPagina,
                numPagina: numPagina,
                crachaNome: crachaNome,
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }; 
            this.dispositivoService.listar(requisicao)
            .then(resp => {
                this.$refs.paginacao.atualizar(resp.data.quantidadeDispositivos);   
                this.dispositivos = resp.data.dispositivos;          
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         *
         */
        maisAcoes(dispositivo) {
            let acoes = [
                {label: 'Gerar Código de Ativação', icon: 'pi pi-pencil', idDispositivo:dispositivo.id, command: (event) => {                                
                        for(let i = 0; i < this.dispositivos.length; i++) {
                            if(this.dispositivos[i].id == event.item.idDispositivo) {
                                this.dispositivoEditar = this.dispositivos[i];
                                this.exibirDialogAtivacao = true;
                                break;
                            }
                        } 
                    }
                },
                {label: 'Gerar Código Redefinir Senha', icon: 'pi pi-pencil', idDispositivo:dispositivo.id, command: (event) => {                                
                        for(let i = 0; i < this.dispositivos.length; i++) {
                            if(this.dispositivos[i].id == event.item.idDispositivo) {
                                this.dispositivoEditar = this.dispositivos[i];
                                this.exibirDialogRedefinirSenha = true;
                                break;
                            }
                        } 
                    }
                },
                {label: 'Copiar Código de Ativação', icon: 'pi pi-copy', idDispositivo:dispositivo.id, command: (event) => {                                
                        for(let i = 0; i < this.dispositivos.length; i++) {
                            if(this.dispositivos[i].id == event.item.idDispositivo) {
                                this.copiarCodigoAtivacao(this.dispositivos[i]);
                                break;
                            }
                        } 
                    }
                },
                {label: 'Permissões', icon: 'pi pi-pencil', idDispositivo:dispositivo.id, command: (event) => {                                
                        for(let i = 0; i < this.dispositivos.length; i++) {
                            if(this.dispositivos[i].id == event.item.idDispositivo) {
                                this.dispositivoEditar = {...this.dispositivos[i]};
                                let permissoes = [];
                                if(this.dispositivoEditar.tipo == 'Mob') {
                                    this.dispositivoEditar.permissoes.forEach(p => {
                                        this.permissoesMob.forEach(pMob => {
                                            if(pMob.nome == p.nome) {
                                                pMob.selecionado = p.selecionado;
                                                permissoes.push(pMob);
                                            }
                                        });
                                    });
                                } else {
                                    this.dispositivoEditar.permissoes.forEach(p => {
                                        this.permissoesWeb.forEach(pWeb => {
                                            if(pWeb.nome == p.nome) {
                                                pWeb.selecionado = p.selecionado;
                                                permissoes.push(pWeb);
                                            }
                                        });
                                    });
                                }
                                this.dispositivoEditar.permissoes = permissoes;
                                this.exibirDialogPermissoes = true;
                                break;
                            }
                        } 
                    }
                },
                {label: 'Excluir', icon: 'pi pi-trash', idDispositivo:dispositivo.id, command: (event) => {                                
                        for(let i = 0; i < this.dispositivos.length; i++) {
                            if(this.dispositivos[i].id == event.item.idDispositivo) {
                                this.dispositivoEditar = this.dispositivos[i];
                                this.exibirDialogConfirmarExcluir = true;
                                break;
                            }
                        } 
                    }
                }
            ];           
            return acoes;
        },
        /**
         * 
         */
        validarTab(event) {
            if(event.tab.header == 'Dispositivos') {
                if(this.cnpjs.length == 0) {
                    this.cnpjs = this.$refs.ikFiltroFuncionarios.getCnpjs();
                }
            }
        },
        /**
         * 
         */
        formatarData(strData) {
            let data = '';
            if(strData) {
                let partesDataHora = strData.split(' ');
                let partesData = partesDataHora[0].split('-');
                data = partesData[2]+'/'+partesData[1]+'/'+partesData[0]+' '+partesDataHora[1];
            } 
            return data;
        },        
        /**
         * 
         */
        fecharNovo() {
            this.exibirDialogPermissoes = false;
            this.exibirDialogDispositivo = false;
            this.tipoDispositivoSelecionado = null;
        }
	},
	created() {        
        this.dispositivoService = new DispositivoService();		        
	},
    beforeDestroy() {
        this.pararTimeout = true;
    },
    components: {
        'IKFiltroFuncionarioContrato': IKFiltroFuncionarioContrato,      
        'Paginacao': Paginacao,
    }
}
</script>
